import { render } from "./SeparateRecommendedCourse.vue?vue&type=template&id=15265c60&scoped=true"
import script from "./SeparateRecommendedCourse.vue?vue&type=script&lang=js"
export * from "./SeparateRecommendedCourse.vue?vue&type=script&lang=js"

import "./SeparateRecommendedCourse.vue?vue&type=style&index=0&id=15265c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15265c60"]])

export default __exports__